var map = {
	"./SettingsPanel.vue": "./src/widget-board/settings-panel/SettingsPanel.vue",
	"./SettingsPanelCustomCheckbox.vue": "./src/widget-board/settings-panel/SettingsPanelCustomCheckbox.vue",
	"./SettingsPanelCustomCheckboxList.vue": "./src/widget-board/settings-panel/SettingsPanelCustomCheckboxList.vue",
	"./SettingsPanelCustomCustom.vue": "./src/widget-board/settings-panel/SettingsPanelCustomCustom.vue",
	"./SettingsPanelCustomNumber.vue": "./src/widget-board/settings-panel/SettingsPanelCustomNumber.vue",
	"./SettingsPanelCustomRadio.vue": "./src/widget-board/settings-panel/SettingsPanelCustomRadio.vue",
	"./SettingsPanelCustomSection.vue": "./src/widget-board/settings-panel/SettingsPanelCustomSection.vue",
	"./SettingsPanelCustomSelectbox.vue": "./src/widget-board/settings-panel/SettingsPanelCustomSelectbox.vue",
	"./SettingsPanelCustomSortableCheckboxList.vue": "./src/widget-board/settings-panel/SettingsPanelCustomSortableCheckboxList.vue",
	"./SettingsPanelCustomSortableList.vue": "./src/widget-board/settings-panel/SettingsPanelCustomSortableList.vue",
	"./SettingsPanelCustomText.vue": "./src/widget-board/settings-panel/SettingsPanelCustomText.vue",
	"./custom/SettingsPanelCustomAlarmInfoColumnSorting.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomAlarmInfoColumnSorting.vue",
	"./custom/SettingsPanelCustomCustomMessagesRecipients.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomCustomMessagesRecipients.vue",
	"./custom/SettingsPanelCustomCustomMessengerChannel.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomCustomMessengerChannel.vue",
	"./custom/SettingsPanelCustomCustomQualificationsSorting.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomCustomQualificationsSorting.vue",
	"./custom/SettingsPanelCustomCustomStatusColumnsSorting.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomCustomStatusColumnsSorting.vue",
	"./custom/SettingsPanelCustomCustomStatusSorting.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomCustomStatusSorting.vue",
	"./custom/SettingsPanelCustomGroupSelect.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomGroupSelect.vue",
	"./custom/SettingsPanelCustomMapType.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomMapType.vue",
	"./custom/SettingsPanelCustomVehicleStatusColumnSorting.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomVehicleStatusColumnSorting.vue",
	"./custom/SettingsPanelCustomVehicleStatusHistoryVehicles.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomVehicleStatusHistoryVehicles.vue",
	"./custom/SettingsPanelCustomVehicleStatusVehicleSorting.vue": "./src/widget-board/settings-panel/custom/SettingsPanelCustomVehicleStatusVehicleSorting.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/widget-board/settings-panel sync recursive ^\\.\\/.*\\.vue$";